import { InjectionToken } from '@angular/core';
import { ExternalTags } from '../model/external-tags';
import { RequestData } from '../model/request-data';
import { HotelsPromotionalDiscount } from '../clients/travel-board/travel-board.types';

export const ASSETS_PATH = new InjectionToken<string>('ASSETS_PATH');

export const IFOOD_REDIRECT_TO = new InjectionToken<string>(
  'IFOOD_REDIRECT_TO'
);

export const EXTERNAL_TAGS_TOKEN = new InjectionToken<ExternalTags>(
  'EXTERNAL_TAGS_TOKEN'
);
export const PAGE_TITLE_TOKEN = new InjectionToken<string>('PAGE_TITLE_TOKEN');

export const REQUEST_DATA = new InjectionToken<RequestData>('REQUEST_DATA');

export const HOTELS_PROMOTIONAL_DISCOUNT_RESPONSE =
  new InjectionToken<HotelsPromotionalDiscount>(
    'HOTELS_PROMOTIONAL_DISCOUNT_RESPONSE'
  );
